
const templateUrls = {
  materialTypes: 'https://tf-api-prod-public.s3.amazonaws.com/import_templates/import_material_template_v3.csv',
  equipmentTypes: 'https://tf-api-prod-public.s3.amazonaws.com/import_templates/import_equipment_template_v2.csv',
  laborTypes: 'https://tf-api-prod-public.s3.amazonaws.com/import_templates/import_labor_template_v1.csv',
}

export default templateUrls
